<h1 mat-dialog-title class="ai-assist-title">
  <img class="ai-assist-title-icon" src="assets/images/action-tracker-ai-icon-animated.svg" alt="" />
  {{ 'page.artificialIntelligence.assistButton' | translate }}
</h1>
@if (hasResult()) {
  <div mat-dialog-content class="ai-assist-content">
    <p class="ai-assist-subtitle">{{ config().previewSubtitleKey | translate }}</p>
    <ng-container [ngTemplateOutlet]="resultTemplate()" />
  </div>
  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="tryAgain.emit()">
      <mat-icon>arrow_back</mat-icon>
      {{ 'page.artificialIntelligence.assistDialog.tryAgain' | translate }}
    </button>
    <ng-container [ngTemplateOutlet]="resultActionsTemplate()" />
  </mat-dialog-actions>
} @else {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div mat-dialog-content class="ai-assist-content">
      @if (isLoading()) {
        <!-- The request stays in the form controls while this is shown, so a failed call comes back to it. -->
        <div class="ai-assist-loading" role="status" aria-live="polite">
          <app-ai-illustration class="ai-assist-loading-illustration" />
          <p class="ai-assist-loading-text">{{ config().loadingKey | translate }}</p>
        </div>
      } @else {
        @if (modes().length) {
          <app-segmented-button
            class="ai-assist-mode"
            [options]="modes()"
            [value]="source()"
            captionKey="page.artificialIntelligence.assistDialog.modes.label"
            (valueChange)="sourceChange.emit($event)"
          />
        }
        <p class="ai-assist-subtitle">{{ config().subtitleKey | translate }}</p>

        <div class="ai-assist-section-label">
          {{ 'page.artificialIntelligence.assistDialog.quickActions' | translate }}
        </div>
        <div class="ai-assist-actions" role="group">
          @if (isLoadingQuickActions()) {
            <mat-progress-spinner mode="indeterminate" diameter="20" />
          } @else {
            <!-- The labels come from the database, already in the viewer's language: no translate pipe here. -->
            @for (action of quickActions(); track action.key) {
              <button
                type="button"
                class="ai-assist-action"
                [class.is-selected]="selectedAction() === action.key"
                [attr.aria-pressed]="selectedAction() === action.key"
                [disabled]="action.isDisabled"
                (click)="onQuickActionClick(action.key)"
              >
                <mat-icon>{{ action.icon }}</mat-icon>
                <span>{{ action.label }}</span>
              </button>
            }
          }
        </div>

        <app-segmented-button
          class="ai-assist-context"
          [captionKey]="contextLevelCaptionKey"
          [options]="contextLevelOptions"
          [value]="contextLevel()"
          (valueChange)="onContextLevelChange($event)"
        />

        <mat-form-field appearance="outline" class="w-100 ai-assist-prompt">
          <mat-label>{{ 'page.artificialIntelligence.assistDialog.promptLabel' | translate }}</mat-label>
          <textarea
            matInput
            rows="3"
            formControlName="prompt"
            [required]="isPromptRequired()"
            [placeholder]="config().promptPlaceholderKey | translate"
          ></textarea>
          <mat-error [control]="form.controls.prompt"></mat-error>
          @if (isPromptRequired()) {
            <mat-hint>{{ 'page.artificialIntelligence.assistDialog.promptRequiredHint' | translate }}</mat-hint>
          }
        </mat-form-field>
      }
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" type="button" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <!-- One button per state: a `mat-icon` is only placed next to the label as a direct child of the button. -->
      @if (isLoading()) {
        <button mat-flat-button type="submit" [disabled]="isLoading()">
          <mat-progress-spinner mode="indeterminate" diameter="18" />
          {{ 'page.artificialIntelligence.assistDialog.generating' | translate }}
        </button>
      } @else {
        <button mat-flat-button type="submit" [disabled]="isLoading()">
          <mat-icon>auto_awesome</mat-icon>
          {{ 'page.artificialIntelligence.assistDialog.generate' | translate }}
        </button>
      }
    </mat-dialog-actions>
  </form>
}
